
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[typeOrDistance]/[location]/[month]",
      function () {
        return require("private-next-pages/[typeOrDistance]/[location]/[month].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[typeOrDistance]/[location]/[month]"])
      });
    }
  